import React from 'react';
import AntRow from 'antd-core/es/row';

const Row = React.forwardRef((props, ref) => {
    return React.createElement(AntRow, Object.assign({ "data-testid": 'tend-ui-row' }, props, { ref: ref }));
});
Row.displayName = 'Row';

export { Row };
//# sourceMappingURL=Row.js.map
